import { createContext } from "react";

type StepAction = (step: number) => unknown;

export const StepActionContext = createContext<StepAction>(() => {});

export const AnomalyIsDemoDataTagVisibleContext = createContext<boolean>(false);
